import jQuery from 'jquery';
import angular from 'angular';

/* @ngInject */
export default function ParametricBuilderService($window, CacheService, SideMenuCacheService, DefinitionParameterApiService, SleuthService) {
    return {
        hideAllDropDowns: function (filters, filter) {
            angular.forEach(filters, function (value) {
                if (value !== filter) {
                    value.showList = false;
                    if (value.handleWindowClick !== undefined) {
                        jQuery($window).unbind('click', value.handleWindowClick);
                    }
                }
            });
        },
        createClickEvents: function (filter, scope, inputElem) {
            if (filter.handleParentClick === undefined) {
                filter.handleParentClick = function (e) {
                    if (filter.showAllList || filter.showFilteredList) {
                        e.stopPropagation();
                    }
                };
            }

            if (filter.handleWindowClick === undefined) {
                filter.handleWindowClick = function () {
                    jQuery(inputElem).unbind('click', filter.handleParentClick);
                    jQuery($window).unbind('click', filter.handleWindowClick);
                    scope.$apply(function () {
                        filter.showAllList = false;
                        filter.showFilteredList = false;
                    });
                };
            }
        },
        addClickEvents: function (filter, inputElem) {
            jQuery(inputElem).unbind('click', filter.handleParentClick).bind('click', filter.handleParentClick);
            jQuery($window).unbind('click', filter.handleWindowClick).bind('click', filter.handleWindowClick);
        },
        buildQueryData: function (definitionParameters, filterExternally) {
            let queryData;
            const parameterAndValueIds = [];
            const targetDefinitionIds = SleuthService.buildTargetDefinitionIdsFromDefinition();

            if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().queryParameterValues !== undefined) {
                const qpvCount = SleuthService.getSleuthData().queryParameterValues.length;
                for (let i = 0; i < qpvCount; ++i) {
                    SleuthService.getSleuthData().queryParameterValues[i].existOnDP = false;
                }
            }

            definitionParameters.forEach(function (dp) {
                let parameterAndValueId;
                const sleuthData = SleuthService.getSleuthData();

                if (dp.query !== undefined) {
                    parameterAndValueId = {
                        parameterId: dp.query.parameterId,
                        parameterValueIds: [],
                        oldParameterValueIds: []
                    };

                    if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().queryParameterValues !== undefined) {
                        const sleuthParameterValuesCount = sleuthData.queryParameterValues.length;

                        for (let i = 0; i < sleuthParameterValuesCount; ++i) {
                            if (sleuthData.queryParameterValues[i].parameterId === parameterAndValueId.parameterId) {
                                SleuthService.getSleuthData().queryParameterValues[i].existOnDP = true;
                                const pvidsCount = parameterAndValueId.parameterValueIds.length;

                                for (let j = 0; j < pvidsCount; ++j) {
                                    if (parameterAndValueId.parameterValueIds[j] !== sleuthData.queryParameterValues[i].id) {
                                        // For loop won't executed because parameterAndValueId.oldParameterValueIds.length return always 0
                                        const oldPvidsCount = parameterAndValueId.oldParameterValueIds.length;

                                        for (let k = 0; k < oldPvidsCount; ++k) {
                                            if (parameterAndValueId.oldParameterValueIds[k] !== parameterAndValueId.parameterValueIds[j]) {
                                                parameterAndValueId.oldParameterValueIds.push(sleuthData.queryParameterValues[i].id);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // In case multi selection (including multi radion button)
                    if (dp.query.selectedFormattedValues !== undefined
                        && dp.query.selectedFormattedValues.length > 0) {

                        // TODO this could be changed to a map for more efficiency
                        dp.query.selectedFormattedValues.forEach(function (selectedValue) {
                            parameterAndValueId.parameterValueIds.push(selectedValue.id);
                        });

                        dp.query.selectedFormattedValue = undefined; // reset the Selected Formatted Value
                    } else if (dp.query.selectedFormattedValues === undefined && dp.query.id !== undefined) { // In case single radio button
                        parameterAndValueId.parameterValueIds.push(dp.query.id);
                    }

                    if (parameterAndValueId.parameterValueIds.length > 0 || parameterAndValueId.oldParameterValueIds.length > 0) {
                        parameterAndValueIds.push(parameterAndValueId);
                    }
                }

                if (dp.unknownValue) {
                    // parameterIds.push(dp.query.parameterId);
                    parameterAndValueId = {
                        parameterId: dp.unknownValue.parameterId,
                        parameterValueIds: [dp.unknownValue.id],
                        oldParameterValueIds: []
                    };

                    if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().queryParameterValues !== undefined) {
                        let sleuthParameterValuesCount = SleuthService.getSleuthData().queryParameterValues.length;
                        for (let i = 0; i < sleuthParameterValuesCount; ++i) {
                            if (sleuthData.queryParameterValues[i].parameterId === parameterAndValueId.parameterId) {
                                SleuthService.getSleuthData().queryParameterValues[i].existOnDP = true;
                            }
                        }
                    }
                    parameterAndValueIds.push(parameterAndValueId);
                }
            });

            if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().queryParameterValues !== undefined) {
                const sleuthParameterValuesCount = SleuthService.getSleuthData().queryParameterValues.length;
                for (let i = 0; i < sleuthParameterValuesCount; ++i) {
                    if (!SleuthService.getSleuthData().queryParameterValues[i].existOnDP) {
                        parameterAndValueIds.push({
                            parameterId: SleuthService.getSleuthData().queryParameterValues[i].parameterId,
                            parameterValueIds: [SleuthService.getSleuthData().queryParameterValues[i].id],
                            oldParameterValueIds: []
                        });
                    }
                }
            }


            queryData = {
                targetDefinitionIds: targetDefinitionIds,
                values: parameterAndValueIds,
                targetMfgs: []
            };

            // -1 means changed filterExternally to empty
            if (filterExternally) {
                let i = queryData.values.length;
                while (i--) {
                    if (queryData.values[i].parameterId === 3) {
                        queryData.values.splice(i, 1);
                    }
                }
                if (filterExternally.length > 0) {
                    queryData.values.push({
                        parameterId: 3,
                        parameterValueIds: filterExternally,
                        oldParameterValueIds: []
                    });
                }
            }
            return queryData;
        },
        updateCache: function (definition, callBack) {
            CacheService.storeDefinition(definition);
            CacheService.getParentDefinition().length = 0;
            if (CacheService.getDefinition() !== undefined) {
                DefinitionParameterApiService.getDefinitionParameterByDefinitionAndDisplayArea(CacheService.getDefinition().id, 'PARAMETRIC_BUILDER', function (definitionParameters) {
                    SideMenuCacheService.sidemenu.length = 0;
                    for (let i = 0; i < definitionParameters.length; ++i) {
                        if (definitionParameters[i].parameterValues.length > 0) {
                            SideMenuCacheService.sidemenu.push(definitionParameters[i]);
                            SleuthService.fillMenuValue(definitionParameters[i]);
                        }
                    }
                    callBack(SideMenuCacheService.sidemenu);
                }, function (error) {
                    console.error('An error occurred while updating the Cache', error);
                });
            }
        },
        getCurrentRootDefinition: function () {
            const definitions = CacheService.getAllDefinitions();
            let definition;
            if (CacheService.getParentDefinition().length > 0) {
                definition = CacheService.getParentDefinition()[0];
            } else { // in case of root definition
                definition = CacheService.getDefinition();
            }
            for (let i = 0; i < definitions.length; ++i) {
                if (definition && definitions[i].id === definition.id) {
                    return definitions[i];
                }
            }
            return undefined;
        }

    };
}
